import React, { useEffect, useState } from "react";
import "./member.css";
import { dateFormat, dateTimeFormat } from "../../services/misc.functions";
import { ApiService } from "lib/http.service";
import { env } from "../../constants/global.vars";

const statusMap: any = {
    0: { label: "Beklemede", className: "bg-warning text-dark" },
    1: { label: "Oynandı", className: "bg-primary" },
    2: { label: "Kazandı", className: "bg-success" },
    3: { label: "Kaybetti", className: "bg-danger" },
    4: { label: "İptal", className: "bg-secondary" },
    5: { label: "Oynama Hatası", className: "bg-dark" },
    6: { label: "İade", className: "bg-info text-dark" },
    7: { label: "Hazır Kupon", className: "bg-light text-dark" }
}

const disciplineMap: any = {
    "MATCHDAY SOCCER 3": "FUTBOL LIGI",
    "SOCCER 3": "FUTBOL",
    "PRO LIG": "PRO LIG",
    "BASKETBALL": "BASKETBOL",
    "STOCK CARS": "ARABA YARIŞI",
    "LUCKY CARS": "ŞANSLI ARABALAR",
    "MARBLES": "MISKET YARIŞI"
};

export function MemberVirtualTickets() {
    const [tabs, setTabs] = useState([{ value: "tümü", label: "Tümü", content: <VirtualTickets code={null} /> }]);
    const [selectedTab, setSelectedTab] = useState(tabs[0]);

    const handleSelect = (e: any) => {
        if (e.target.id) {
            setSelectedTab(tabs[e.target.id]);
        }
    };

    // useEffect(() => {
    //     getGameTypes();
    // }, [window.location.pathname]);


    // const getGameTypes = () => {
    //     let api = new ApiService();

    //     api.start("get", env.accounting_api + "/games/api/list-game/", null, false).then((res: any) => {
    //         if (res.data) {
    //             const _gameTypes = res.data.filter((game: any) => game.vendor === 6).map((game: any) => {
    //                 return game
    //             });

    //             const _tabs = _gameTypes.map((game: any) => {
    //                 return {
    //                     value: game.id,
    //                     label: game.name,
    //                     content: <VirtualTickets code={game.code} />
    //                 }
    //             });

    //             setTabs([{ value: "tümü", label: "Tümü", content: <VirtualTickets code={null} /> }, ..._tabs]);

    //             console.log(_gameTypes)
    //         }
    //     });
    // }

    return (
        <>
            <h1>Sanal Oyun Biletlerim</h1>
            <div className="page-widget">
                <svg style={{ display: "none" }}>
                    <defs>
                        <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"></path>
                    </defs>
                </svg>

                {/* Tab Header */}
                <div className={"tab-scroll"}>
                    <ul className="nav nav-tabs">
                        {tabs.map(({ value, label }: { value: string; label: string }, index) => {
                            return (
                                <li
                                    key={`tabs-index-${index}`}
                                    className={`nav-item ${selectedTab.value === value ? "active" : ""}`}
                                    onClick={handleSelect}
                                >
                                    <svg className="left" viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                    <a className="nav-link" id={`${index}`}>
                                        {label.toUpperCase()}
                                    </a>
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none">
                                        <use xlinkHref="#tabshape"></use>
                                    </svg>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="p-1 p-lg-3">{selectedTab.content}</div>
            </div>
        </>
    );
}

function VirtualTickets({ code }: { code: string | null }) {
    const [tickets, setTickets] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [pagination, setPagination] = useState({ total_page: 0, current_page: 0 });
    const [expandedId, setExpandedId] = useState<string | null>(null);

    useEffect(() => {
        setTickets([]);
        loadData(0, true);
    }, [code]);

    const loadData = (pageNum: number, isFirstLoad: boolean = false) => {
        setLoading(true);
        let api = new ApiService();
        api.start("post", env.accounting_api + "/games/api/list-coupon/", {
            vendor: 6,
            detail: true,
            page: pageNum,
            game_id: code
        }, true)
            .then((res: any) => {
                const newTickets = res.data || [];
                const meta = res.metadata;
                if (isFirstLoad) setTickets(newTickets);
                else setTickets(prev => [...prev, ...newTickets]);

                if (meta) {
                    setPagination({ total_page: meta.total_page, current_page: meta.page });
                    setPage(meta.page);
                }
            })
            .finally(() => setLoading(false));
    };

    const toggleDetail = (id: string) => {
        setExpandedId(expandedId === id ? null : id);
    };

    return (
        <div className="table-responsive">
            <table className="table table-borderless betting-table ticket-table custom-theme-table">
                <thead>
                    <tr>
                        <th>Bilet</th>
                        <th>İşlem Tarihi</th>
                        <th>Miktar</th>
                        <th>Durum</th>
                    </tr>
                </thead>
                <tbody>
                    {tickets.map((ticket: any, index: number) => {
                        return <React.Fragment key={`${ticket.transaction_id}-${index}`}>
                            <tr
                                onClick={() => toggleDetail(ticket.transaction_id)}
                                style={{ cursor: 'pointer' }}
                                className={expandedId === ticket.transaction_id ? 'table-active border-bottom-0' : 'border-bottom'}
                            >
                                <td>
                                    <div className="p-2">
                                        <span className="game-name fw-bold">{ticket.integrator_transaction_id}</span>
                                    </div>
                                </td>
                                <td>{dateTimeFormat(ticket.transaction_date)}</td>
                                <td>{ticket.amount} ₺</td>
                                <td>
                                    <span className={`badge ${statusMap[ticket.status]?.className || 'bg-secondary'}`}>
                                        {statusMap[ticket.status]?.label || 'Bilinmeyen'}
                                    </span>
                                </td>
                            </tr>

                            {expandedId === ticket.transaction_id && (
                                <tr className="detail-row">
                                    <td colSpan={5} className="p-1 bg-white">
                                        <div className="bet-detail-container bg-light border rounded p-3">
                                            {ticket.coupon_detail?.map((det: any, dIdx: number) => (
                                                <div key={dIdx} className="d-flex align-items-center mb-3 border-bottom pb-2">
                                                    <div className="date-box bg-light text-center p-2 rounded me-3" style={{ minWidth: '60px' }}>
                                                        <div className="small fw-bold">{dateFormat(new Date(det.eventStartDate).toDateString())}</div>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <div className="text-muted small">
                                                            {disciplineMap[det.disciplineName] || det.disciplineName}
                                                        </div>
                                                        <div className="fw-bold">{det.eventName}</div>
                                                        <div className="small text-muted">
                                                            {det.marketName}: <strong>{det.selectionName} ({det.odds})</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className="bet-summary mt-3 d-flex justify-content-between align-items-end">
                                                <div className="summary-left small">
                                                    {/* <div>Çift bonus (1.05) <span className="fw-bold">9,55 ₺</span></div> */}
                                                </div>
                                                <div className="summary-right text-end d-flex flex-column align-items-end gap-2">
                                                    <div className="small">Bahis tutarı: <strong>{ticket.amount}</strong></div>
                                                    {ticket.winning > 0 && <div className="small">Kazanç: <strong>{ticket.winning}</strong></div>}
                                                    <td>
                                                        <span className={`badge ${statusMap[ticket.status]?.className || 'bg-secondary'}`}>
                                                            {statusMap[ticket.status]?.label || 'Bilinmeyen'}
                                                        </span>
                                                    </td>
                                                </div>
                                            </div>

                                            <div className="mt-3 border rounded p-2 bg-light">
                                                <div className="row g-2 small">
                                                    <div className="col-6"><strong>Bilet kodu:</strong> {ticket.integrator_transaction_id}</div>
                                                    <div className="col-6"><strong>Satış tarihi:</strong> {dateTimeFormat(ticket.transaction_date)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    })}
                </tbody>
            </table>

            <div className="text-center mt-4 mb-5">
                {loading ? (
                    <div className="spinner-border text-primary" role="status"></div>
                ) : (
                    pagination.current_page < pagination.total_page && (
                        <button className="btn btn-primary btn-md px-5" onClick={() => loadData(page + 1)}>
                            Daha Fazla Yükle
                        </button>
                    )
                )}
            </div>
        </div>
    );
}